import * as React from "react";

const ChevronIcon = (props: any) => (
  <svg
    className={props.className}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_183_9781"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="42"
      height="43"
    >
      <rect width="42.0004" height="42.0004" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_183_9781)">
      <path
        d="M21.0001 26.9501L10.5 16.45L12.95 14L21.0001 22.0501L29.0502 14L31.5002 16.45L21.0001 26.9501Z"
        fill="#1B1817"
      />
    </g>
  </svg>
);

export default ChevronIcon;
